var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { formatters } from "../../core/common";

export var mappedFormatters = formatters.map(function (f) {
  return _extends({}, f, {
    value: f.key
  });
});

export var findFormatterByProp = function findFormatterByProp(prop, searchedValue, returnProp) {
  var formatter = mappedFormatters.find(function (f) {
    return f[prop] === searchedValue;
  });

  if (!returnProp || !formatter) {
    return formatter;
  }

  return formatter[returnProp];
};